import React from 'react'; 

const SecondaryHeading = ({ children }) => {
  return (
    <p className="sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold">{children}</p>
  );
};

export default SecondaryHeading;
